import { render } from "./ExtractoCuentasView.vue?vue&type=template&id=47ceb2ca"
import script from "./ExtractoCuentasView.vue?vue&type=script&lang=js"
export * from "./ExtractoCuentasView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__